import '../../dmView/style/App.css';

const IdlePopUp = ({page}) => {
    return (
        <div className='playerViewTimeoutContainer grow'>
            <div className='titleFontFamily'><b>{page} session expired</b></div>
            <div className='monsterSearchDetailText'>(No DM input for 6 hours)</div>
            <button className='dmViewButton' style={{marginTop: "10px"}} onClick={() => window.location.reload()}>Refresh {page} Session</button>
        </div>
    );
};

export default IdlePopUp;